var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.54 2.26099H7.92C9.33 2.26099 10.46 3.3971 10.46 4.79106V8.1589C10.46 9.56175 9.33 10.688 7.92 10.688H4.54C3.14 10.688 2 9.56175 2 8.1589V4.79106C2 3.3971 3.14 2.26099 4.54 2.26099ZM4.54 13.5922H7.92C9.33 13.5922 10.46 14.7194 10.46 16.1223V19.4901C10.46 20.8831 9.33 22.0192 7.92 22.0192H4.54C3.14 22.0192 2 20.8831 2 19.4901V16.1223C2 14.7194 3.14 13.5922 4.54 13.5922ZM19.4601 2.26099H16.0801C14.6701 2.26099 13.5401 3.3971 13.5401 4.79106V8.1589C13.5401 9.56175 14.6701 10.688 16.0801 10.688H19.4601C20.8601 10.688 22.0001 9.56175 22.0001 8.1589V4.79106C22.0001 3.3971 20.8601 2.26099 19.4601 2.26099ZM16.0801 13.5922H19.4601C20.8601 13.5922 22.0001 14.7194 22.0001 16.1223V19.4901C22.0001 20.8831 20.8601 22.0192 19.4601 22.0192H16.0801C14.6701 22.0192 13.5401 20.8831 13.5401 19.4901V16.1223C13.5401 14.7194 14.6701 13.5922 16.0801 13.5922Z",
    fill: "#1A374E",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home_icon.42464289048d2c45440669b9067d5e9c.svg";
export { ForwardRef as ReactComponent };